module.exports = __webpack_public_path__ + "static/img/halangahu-jacob.9b95bd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/halangahu-jacob.jpg
// module id = DINI
// module chunks = 0